module.exports = __webpack_public_path__ + "img/kleidi-1.4b5d8f80.png";